import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export const Categories = ({
  categories = [],
  themeColor = "#f5f5f5",
  navbarTextColor = "#ffffff",
  categoryCardNo = 2,
}) => {
  const [selectedCategory, setSelectedCategory] = useState(
    categories[0]?.id || null
  );
  const [font, setFont] = useState("");

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setFont(parsedStyle.web_font);
    }
  }, []);

  const BASE_SUBCATEGORY_IMAGE_URL =
    "https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories";

  const handleCategoryClick = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  return (
    <div className="bg-white absolute right-0 mt-4 md:w-[600px] shadow-lg rounded-md p-4 flex">
      {/* Left Column: Categories */}
      <div
        className="w-1/2 max-h-96 overflow-y-auto scrollbar-hide"
        style={{ scrollbarWidth: "none", fontFamily: font }}
      >
        {categories.map((item) => (
          <div
            key={item.id}
            className="flex items-center gap-4 p-2 cursor-pointer rounded-md"
            style={{
              backgroundColor:
                selectedCategory === item.id ? themeColor : "transparent",
              color:
                selectedCategory === item.id
                  ? navbarTextColor
                  : "black",
            }}
            onClick={() => handleCategoryClick(item.id)}
          >
            {/* Category Image */}
            {(categoryCardNo === 1 || categoryCardNo === 2) && (
              <img
                className="rounded-full h-12 w-12"
                alt={item.label}
                src={item.imgSrc}
              />
            )}

            {/* Category Name (ALWAYS VISIBLE) */}
            <span className="font-bold text-lg">
              {item.label}
            </span>
          </div>
        ))}
      </div>

      {/* Right Column: Subcategories */}
      <div
        className="w-1/2 max-h-96 overflow-y-auto scrollbar-hide"
        style={{
          scrollbarWidth: "none",
          backgroundColor: themeColor,
          fontFamily: font,
        }}
      >
        {selectedCategory &&
          categories
            .find((item) => item.id === selectedCategory)
            ?.subcategories?.map((subItem) => (
              <Link
                to="/productlist"
                state={{
                  subcategoryName: subItem.sub_category_name,
                  sub_cat_id: subItem.sub_category_auto_id,
                }}
                key={subItem.sub_category_auto_id}
                className="no-underline text-inherit"
              >
                <div className="flex items-center gap-4 p-2">
                  {/* Subcategory Image */}
                  {(categoryCardNo === 1 || categoryCardNo === 2) && (
                    <img
                      className="rounded-full h-10 w-10"
                      src={`${BASE_SUBCATEGORY_IMAGE_URL}/${subItem.subcategory_image_app}`}
                      alt={subItem.sub_category_name}
                    />
                  )}

                  {/* Subcategory Name */}
                  <span className="text-lg text-black">
                    {subItem.sub_category_name}
                  </span>
                </div>
              </Link>
            ))}
      </div>
    </div>
  );
};
